module.exports = __webpack_public_path__ + "img/ysgj_047@2x.e5ab752d.png";